/* @flow */

const KEY_DEFAULT_TEAM = "default-team";

const KEY_DEFAULT_LOCALE = "default-locale";

const KEY_HOME_TEAM_COLOR = "home-team-color";
const KEY_AWAY_TEAM_COLOR = "away-team-color";

const KEY_TOKEN = "token";

export function setToken(token: string) {
  localStorage.setItem(KEY_TOKEN, token);
}

export function getToken() {
  return localStorage.getItem(KEY_TOKEN);
}

export function clearToken() {
  localStorage.removeItem(KEY_TOKEN);
}

export function clearAll() {
  localStorage.clear();
}

export function getHomeTeamColor() {
  const color = localStorage.getItem(KEY_HOME_TEAM_COLOR);
  return color || "#0040ff";
}

export function setHomeTeamColor(color: string) {
  localStorage.setItem(KEY_HOME_TEAM_COLOR, color);
}

export function getAwayTeamColor() {
  const color = localStorage.getItem(KEY_AWAY_TEAM_COLOR);
  return color || "#ffbf00";
}

export function setAwayTeamColor(color: string) {
  localStorage.setItem(KEY_AWAY_TEAM_COLOR, color);
}

export function setDefaultLocale(local: string) {
  localStorage.setItem(KEY_DEFAULT_LOCALE, local);
}

export function getDefaultLocale() {
  const locale = localStorage.getItem(KEY_DEFAULT_LOCALE);
  return locale || "en-GB";
}

export function setDefaultTeam(teamId: number) {
  localStorage.setItem(KEY_DEFAULT_TEAM, teamId.toString());
}

export function getDefaultTeam() {
  const strTeamId = localStorage.getItem(KEY_DEFAULT_TEAM);
  return strTeamId ? parseInt(strTeamId) : -1;
}

export function clearDefaultTeam() {
  localStorage.removeItem(KEY_DEFAULT_TEAM);
}
